import { Box, styled } from '@mui/material';

export const EmployeeListContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[2],
  borderRadius: '2px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  flexGrow: 2,
  height: '95vh',
  width: '100%',
  maxWidth: '100%',
  minHeight: 0,
  padding: theme.spacing(2),
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    boxShadow: 'none',
    flex: 1,
    height: '100%',
    padding: theme.spacing(1),
  },
}));

export const Employee = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.background.default}`,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  minHeight: '52px',
  paddingInline: theme.spacing(8),
  width: '100%',
  '&:hover': {
    backgroundColor: theme.palette.background.default,
    cursor: 'pointer',
  },
  [theme.breakpoints.down('sm')]: {
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    padding: theme.spacing(1.5, 0),
  },
}));

export const EmployeesList = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  gap: '4px',
  minHeight: 0,
  display: 'flex',
  width: '100%',
  overflowY: 'auto',
  scrollbarWidth: 'thin',
  padding: theme.spacing(2),
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1, 0),
  },
}));
